module.exports = __webpack_public_path__ + "static/MT_Benefit-04.cc9a71dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/benefit-icons/MT_Benefit-04.png
// module id = 1464
// module chunks = 169858455373905